module.exports = __webpack_public_path__ + "static/media/ag.d024cb54.svg";